import React from 'react'
import styles from '../../Forms.css'
import EditIcon from 'static/images/icons/pencil-outline.svg'
import { Field } from 'redux-form'
import { requiredValidation } from '../formValidations'

/**
 * name: fieldName,
 * disabled: a piece of state for form field edit mode,
 * toggleDisable: a function to toggle disabled/ edit mode state
 * config: KPA config for the particular fieldName({isRequired, isVisible, isRxVisible})
 * validate: validation functions list
 */

const InputField = props => {
  const {
    name,
    disabled,
    toggleDisable,
    config = {},
    validate = [],
    required,
    readOnly = false,
    ...otherProps
  } = props
  const { isRequired = false, isVisible = true } = config
  // if the field is a required field add required validation

  if (isRequired || required) {
    validate.push(requiredValidation)
  }
  const editClassName =
    disabled && disabled[name] ? 'editIcon' : 'editIconActive'
  const inputElment = (
    <React.Fragment>
      {!readOnly && (
        <div
          className={styles[editClassName]}
          onClick={() => toggleDisable(name)}
        >
          <EditIcon />
        </div>
      )}
      <Field
        name={name}
        disabled={readOnly || (disabled && disabled[name])}
        validate={validate}
        {...otherProps}
        required={isRequired || required}
      />
    </React.Fragment>
  )
  if (isVisible) {
    if (name === 'notes') {
      return inputElment
    }
    return <div className={styles.editLabelGroup}>{inputElment}</div>
  }
  return <InputFieldPlaceholder />
}

export function InputFieldPlaceholder() {
  return (
    <div className={styles.editLabelGroup}>
      <div className={styles.editPlaceholder} />
      {/* Empty Space */}
    </div>
  )
}

export default InputField



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/components/InputField/InputField.jsx